<template>
  <div v-if="!loading" class="wrapper">
    <div v-if="step === 1" style="max-width: 100%;">
      <div v-html="action.html" />
      <div v-html="action.question" />
      <methodology
        :surveySelectedColor="action.templatebuttonselected"
        :surveyTextColor="action.textcolor"
        :surveyBorderColor="action.border"
        :surveyColor="action.color"
        :actionMetric="action.metric"
        class="mt-2 mb-2"
      />
      <button v-if="widgetStyleButton === 'block'" class="btn btn-block" @click="saveAnswer">Enviar</button>
      <button
        v-else
        :disabled="loadingSave"
        @click="saveAnswer"
        class="next"
        style="float: right;"
      >
        Enviar<i class="fas fa-arrow-right" />
      </button>
    </div>
    <div
      v-else-if="
        step === 2 && action.commentPosition === 'up' && displayCommentArea
      "
      class="comment-area"
    >
      <research-replys
        :metric="action.metric"
        :promotersReply="action.reply.promoters"
        :neutralReply="action.reply.neutral"
        :detractorsReply="action.reply.detractors"
        :grade="testNpsReview"
      />
      <textarea
        name="comment-text-area"
        id="comment-text-area"
        v-model="answer.feedback"
        cols="40"
        rows="4"
      />
      <button v-if="widgetStyleButton === 'block'" class="btn btn-block" @click="sendFeedback">Enviar</button>
      <button v-else @click="sendFeedback" class="next">
        Enviar <i class="fas fa-arrow-right" />
      </button>
    </div>
    <div
      v-else-if="
        step === 2 &&
        action.additionalQuestions[position] &&
        !action.additionalQuestions[position].show &&
        indicatorValuedQuestion(action.additionalQuestions[position])
      "
      :key="position"
      class="addquestions-area"
    >
      <star-rating
        v-if="action.additionalQuestions[position].type === 'REVIEWS'"
        :text="action.additionalQuestions[position].text"
        :item-id="position.toString()"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <like-dislike
        v-if="action.additionalQuestions[position].type === 'LIKE/DISLIKE'"
        :questionText="action.additionalQuestions[position].text"
        :index="position"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <likert
        class="likert-adjust"
        v-if="action.additionalQuestions[position].type === 'LIKERT'"
        :text="action.additionalQuestions[position].text"
        :item-id="position.toString()"
        :colorTemplate="action.color"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
        :template="action.additionalQuestions[position].template"
      />
      <emotion
        v-if="action.additionalQuestions[position].type === 'EMOTION'"
        :questionText="action.additionalQuestions[position].text"
        :index="position"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <multiple-choices
        v-if="action.additionalQuestions[position].type === 'MULTIPLE'"
        :type="action.additionalQuestions[position].multipleType"
        :questionText="action.additionalQuestions[position].text"
        :choices="action.additionalQuestions[position].choices"
        :index="position"
        v-model="action.additionalQuestions[position].addQuestionAnswerMultiple"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <c-sat
        v-if="action.additionalQuestions[position].type === 'CSAT'"
        :text="action.additionalQuestions[position].text"
        :item-id="position.toString()"
        :colorTemplate="action.color"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :template="action.additionalQuestions[position].template"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <nps
        v-if="action.additionalQuestions[position].type === 'NPS'"
        :text="action.additionalQuestions[position].text"
        :item-id="position.toString()"
        :colorTemplate="action.color"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :template="action.additionalQuestions[position].template"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <likertEmotion
        v-if="action.additionalQuestions[position].type === 'LIKERT/EMOTION'"
        :text="action.additionalQuestions[position].text"
        :item-id="position.toString()"
        :colorTemplate="action.color"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <input-type
        v-if="action.additionalQuestions[position].type === 'INPUT'"
        :text="action.additionalQuestions[position].text"
        :index="position"
        :answerText="action.additionalQuestions[position].answerText"
        v-model="action.additionalQuestions[position].answerText"
      />
      <label-question
        v-if="action.additionalQuestions[position].type === 'LABEL'"
        :text="action.additionalQuestions[position].text"
        :index="position"
      />
      <ces
        v-if="action.additionalQuestions[position].type === 'CES'"
        :text="action.additionalQuestions[position].text"
        :index="position"
        v-model="action.additionalQuestions[position].addQuestionAnswer"
        :commentEnabled="action.additionalQuestions[position].commentEnabled"
        :item-id="position.toString()"
        :applicableEnabled="action.additionalQuestions[position].applicableEnabled"
      />
      <contact
        v-if="action.additionalQuestions[position].type === 'CONTACT'"
        :type="action.additionalQuestions[position].multipleType"
        :questionText="action.additionalQuestions[position].text"
        :choices="action.additionalQuestions[position].choices"
        v-model="dataContact"
        :addQuestionTemplate="action.addQuestionTemplate"
      />
      <div class="buttons-area">
        <button v-if="position > 0" @click="returnPosition" class="prev">
          <i class="fas fa-arrow-left" /> Voltar
        </button>
        <p v-if="!existRuleJump" class="guide">
         {{ position + 1 }} - {{ action.additionalQuestions.length }}
        </p>
        <span v-if="position <= 0" />
        <button @click="sendAddQuestion" class="next">
          {{
            position + 1 === action.additionalQuestions.length
              ? 'Finalizar'
              : 'Próximo'
          }}
          <i class="fas fa-arrow-right" />
        </button>
      </div>
    </div>
    <div
      v-else-if="
        step === 2 && action.commentPosition === 'down' && displayCommentArea
      "
      class="comment-area"
    >
      <research-replys
        :metric="action.metric"
        :promotersReply="action.reply.promoters"
        :neutralReply="action.reply.neutral"
        :detractorsReply="action.reply.detractors"
        :grade="testNpsReview"
      />
      <textarea
        name="comment-text-area"
        id="comment-text-area"
        v-model="answer.feedback"
        cols="40"
        rows="4"
      />
      <button v-if="widgetStyleButton === 'block'" class="btn btn-block" @click="sendFeedback">Enviar</button>
      <button v-else @click="sendFeedback" class="next">
        Enviar <i class="fas fa-arrow-right" />
      </button>
    </div>
    <div v-else class="thank-you-area">
      <div
        v-if="action.closingMessageEnabled && closingMessage.html"
        v-html="closingMessage.html"
      ></div>
      <div v-else>
        <h1>Obrigado!</h1>
        <p>Agradecemos a participação!</p>
      </div>
    </div>
  </div>
</template>

<script>
import researchReplys from '@/components/atoms/research-replys';
import methodology from '@/components/molecules/action-templates/methodology';
import ces from '@/components/molecules/metrics/ces';
import contact from '@/components/molecules/metrics/contact';
import cSat from '@/components/molecules/metrics/csat';
import emotion from '@/components/molecules/metrics/emotion';
import inputType from '@/components/molecules/metrics/input-type';
import labelQuestion from '@/components/molecules/metrics/label-question';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import likert from '@/components/molecules/metrics/likert';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import nps from '@/components/molecules/metrics/nps';
import starRating from '@/components/molecules/metrics/reviews';
import bowser from 'bowser';
import { mapState } from 'vuex';
import api from '../../../services/api';

export default {
  components: {
    methodology,
    starRating,
    likeDislike,
    likert,
    researchReplys,
    emotion,
    multipleChoices,
    inputType,
    cSat,
    nps,
    likertEmotion,
    labelQuestion,
    ces,
    contact,
  },
  data: () => ({
    loading: true,
    loadingSave: false,
    step: 1,
    displayStageTwo: false,
    displayCommentArea: true,
    position: 0,
    addquestonAnswer: null,
    action: {
      metric: null,
      color: null,
      templatebuttonselected: null,
      textcolor: null,
      border: null,
      html: null,
      question: null,
      reply: {
        detractors: null,
        neutral: null,
        promoters: null,
      },
      commentPosition: 'up',
      additionalQuestions: [
        {
          type: 'REVIEWS',
          text:
            'Em uma escala de 0 a 10, o quanto você indicaria nossa empresa?',
        },
        {
          type: 'LIKE/DISLIKE',
          text: 'Opaaaa avalia ai, o quanto você indicaria nossa empresa?',
        },
      ],
      closingMessageEnabled: false,
      closingMessage: {},
    },
    invite: {
      token: null,
    },
    answer: {
      id: null,
      feedback: null,
    },
    closingMessage: {
      useLogo: false,
      html: null,
    },
    isPreview: false,
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    indicators: [],
    nextPosition: 0,
    arrayInvert: [],
    existRuleJump: false,
    dataContact: {
      name: null,
      email: null,
      phone: null,
    },
    widgetStyleButton: null,
    additionalQuestions: [],
  }),
  computed: {
    ...mapState('actions', ['testNpsReview']),
  },
  watch: {
    // create watch on testNpsReview to filter questions by conditional profile
    testNpsReview() {
      this.action.additionalQuestions = this.additionalQuestions.filter(item => this.getVisibleConditionalByProfile(item));
    }
  },
  async created() {
    if (this.$route.params.inviteId === 'preview') {
      this.isPreview = true;
    }
    let action = {};
    let invite = {};
    const actionOnLocalStorage = JSON.parse(
      localStorage.getItem('@IndeCX:action-widget'),
    );
    if (actionOnLocalStorage) {
      this.isPreview = true;
      action = actionOnLocalStorage;
      invite = { researchToken: 'fake_token' };
      localStorage.removeItem('@IndeCX:action-widget');
    } else {
      const response = await api.get(
        `/widget/info/${this.$route.params.actionId}/${this.$route.params.inviteId}`,
      );
      action = response.data.action;
      invite = response.data.invite;
    }
    this.$store.state.actions.action = action;
    this.action.html = action.email.template.myHTML;
    this.action.question = action.questionHTML;
    this.action.commentPosition = action.commentPosition;
    this.action.additionalQuestions = action.email.additionalQuestions;
    this.additionalQuestions = action.email.additionalQuestions;
    this.action.reply = action.reply;
    this.action.metric = action.type;
    this.action.closingMessage = action.closingMessage;
    this.action.closingMessageEnabled = action.closingMessageEnabled;
    this.action.color = action.email.template.scale;
    this.action.border = action.email.template.border;
    this.action.textcolor = action.email.template.grade;
    this.action.templatebuttonselected =
      action.email.template.templatebuttonselected;
    this.invite.token = invite.researchToken;
    this.indicators = invite.indicators;
    this.action.html = this.replaceTagNames(
      this.action.html,
      invite.name || '',
    );
    this.action.additionalQuestions.forEach((el) => {
      if(el.logicalRuleEnabled && el.conditionalRule){
        this.existRuleJump = true;
      }

      if (el.type === 'MULTIPLE') {
        el.multipleValues = [];
      } else if (el.type === 'INPUT') {
        el.answerText = null;
      } else {
        el.review = undefined;
      }
    });
    if (this.action.metric.includes('0-10')) {
      this.promotersGrades = [10, 9];
      this.passivesGrades = [8, 7];
      this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
    }
    this.widgetStyleButton = this.$route.query.btn || 'default';
    this.loading = false;
  },
  methods: {
    getVisibleConditionalByProfile(question){
        const metric = this.action.metric;
        const review = this.testNpsReview;
        const { profileEnabled, selectedProfile } = question;

        if (!profileEnabled || !selectedProfile) {
            return true;
        }

        const visibilityConditions = {
            'nps-0-10': {
              promotor: review >= 9,
              neutro: review >= 7 && review <= 8,
              detrator: review <= 6,
            },
            'csat-0-10(media)': {
              promotor: review >= 9,
              neutro: review >= 7 && review <= 8,
              detrator: review <= 6,
            },
            'nps-1-5': {
              promotor: review >= 4,
              neutro: review === 3,
              detrator: review <= 2,
            },
            'ces-1-5': {
              promotor: review >= 4,
              neutro: review === 3,
              detrator: review <= 2,
            },
            'csat-1-5': {
              promotor: review >= 4,
              neutro: review === 3,
              detrator: review <= 2,
            },
            '5-stars': {
              promotor: review >= 4,
              neutro: review === 3,
              detrator: review <= 2,
            },
            'csat-1-5(media)': {
              promotor: review >= 4,
              neutro: review === 3,
              detrator: review <= 2,
            },
            'like-dislike': {
              promotor: review >= 1,
              detrator: review <= 0,
            },
        };

        const conditions = visibilityConditions[metric];
        if (!conditions) {
            return false;
        }

        return conditions[selectedProfile] || false;

      },

      returnPosition(){
        // current position element remover without modifying original array
        const array = [...this.action.additionalQuestions];
        array.splice(this.position)

        // invert the array to be able to find the item before the current one that needs to be displayed
        this.arrayInvert = array.map(function invertItens (item, indice, arrayOriginal){
          return arrayOriginal[arrayOriginal.length - indice - 1];
        });

        let beforeId = null;

        // finds the id of the item that needs to be displayed
        for(let i = 0; i < this.arrayInvert.length; i+=1) {
          if(!this.arrayInvert[i].show){
              beforeId = this.arrayInvert[i].id;
              break;
          }
        }

        // checks in which position of the original array is the id that needs to be displayed (beforeId)
        for(let j = 0; j < this.action.additionalQuestions.length; j+=1){
          if(this.action.additionalQuestions[j].id === beforeId){
            this.position = j;
            break;
          }
        }
      },

      verifyNextQuestion(position, grade){
      if (this.action.additionalQuestions[position].idsDisabled &&
      this.action.additionalQuestions[position].idsDisabled.length > 0) {
        this.action.additionalQuestions[position].idsDisabled.forEach((el) => {
          for (
            let i = 0;
            i < this.action.additionalQuestions.length;
            i += 1
          ) {
            if (this.action.additionalQuestions[i].id === el) {
              this.action.additionalQuestions[i].show = this.isVisible(i,
                this.action.additionalQuestions[position],
                grade,
              );
            }
          }
        });
      }
    },

    isVisible(index, item, value) {
      if (item.logicalRuleEnabled && item.conditionalRule) {
        let res = false;
        switch (item.conditionalRule) {
          case 'equal': // igual
            if (item.type === 'MULTIPLE') {
              if (item.multipleType === 'radio') {
                res =
                  value.multipleValues === item.conditionalValue ? true : false;
              } else {
                res = value.multipleValues.includes(item.conditionalValue);
              }
            } else {
              res =
                Number(value.review) === item.conditionalValue ? true : false;
                if(res === true){
                  this.position = index;
                }
            }
            break;

          case 'differentThan': // diferente
            if (item.type === 'MULTIPLE') {
              if (item.multipleType === 'radio') {
                res =
                  value.multipleValues !== item.conditionalValue ? true : false;
              } else {
                res = value.multipleValues.includes(item.conditionalValue);
              }
            } else {
              res =
                Number(value.review) !== item.conditionalValue ?  true : false;
            }
            break;

          case 'biggerThen': // maior que
            res = value.review > item.conditionalValue ?  true : false;
            break;

          case 'greaterOrEqualTo': // maior ou igual
            res = value.review >= item.conditionalValue ?  true : false;
            break;

          case 'lessThan': // menor que
            res = value.review < item.conditionalValue ?  true : false;
            break;

          case 'lessThanOrEqualTo': // menor ou igual
            res = value.review <= item.conditionalValue ? true : false;
            break;

          default:
            break;
        }
        return res;
      }
      return false;
    },

    async saveAnswer() {
      if (this.testNpsReview !== null && !isNaN(this.testNpsReview)) {
        this.handleClosingMessage();
        if (this.isPreview === true) {
          this.step = 2;
          return;
        }
        this.loadingSave = true;
        const deviceInfo = this.getDeviceInfo();
        this.action.additionalQuestions.forEach((el, index) => {
          if (el.addQuestionAnswer) {
            el.review = el.addQuestionAnswer.review || undefined;
            el.comment = el.addQuestionAnswer.comment || undefined;
            el.conditionalQuestion = null;
          }

          delete this.action.additionalQuestions[index].addQuestionAnswer;
          if (el.addQuestionAnswerMultiple) {
            el.multipleValues =
              el.addQuestionAnswerMultiple.multipleValues || [];
            el.comment = el.addQuestionAnswerMultiple.comment || undefined;
            el.conditionalQuestion = null;
          }

          delete this.action.additionalQuestions[index]
            .addQuestionAnswerMultiple;
        });
        try {
          const response = await api.post('/answer', {
            review: this.testNpsReview,
            feedback: null,
            additionalQuestions: this.action.additionalQuestions,
            channel: 'widget',
            token: this.invite.token,
            anonymousResponse: false,
            deviceInfo,
          });
          this.answer.id = response.data._id;
          this.step = 2;
        } catch (error) {
          window.console.log(error);
        }
        this.loadingSave = false;
      }
    },

    sendFeedback() {
      if (this.isPreview === true) {
        this.displayCommentArea = false;
        return;
      }
      api.put(`/widget/update-answer/${this.answer.id}`, {
        feedback: this.answer.feedback,
      });
      this.displayCommentArea = false;
    },

    addAnswerQuestions(){
      this.action.additionalQuestions.forEach((el, index) => {
        if (el.addQuestionAnswer) {
          el.review = el.addQuestionAnswer.review;
          el.comment = el.addQuestionAnswer.comment || undefined;
          el.conditionalQuestion = null;
        }

        delete this.action.additionalQuestions[index].addQuestionAnswer;

        if (el.addQuestionAnswerMultiple) {
          el.multipleValues = el.addQuestionAnswerMultiple.multipleValues || [];
          el.comment = el.addQuestionAnswerMultiple.comment || undefined;
          el.conditionalQuestion = null;
        }
        delete this.action.additionalQuestions[index].addQuestionAnswerMultiple;
      });
    },

    sendAddQuestion() {
      if (this.isPreview === true) {
        this.addAnswerQuestions();
        this.verifyNextQuestion(this.position, this.action.additionalQuestions[this.position]);
        this.addquestonAnswer = null;
        this.position += 1;
        return;
      }

      this.action.additionalQuestions.forEach((el, index) => {
        if (el.addQuestionAnswer) {
          el.review = el.addQuestionAnswer.review;
          el.comment = el.addQuestionAnswer.comment || undefined;
          el.conditionalQuestion = null;
        }

        if(el.type === 'INPUT' && el.answerText && el.answerText.review !== ''){
          el.conditionalQuestion = null;
        }

        delete this.action.additionalQuestions[index].addQuestionAnswer;

        if (el.addQuestionAnswerMultiple) {
          el.multipleValues = el.addQuestionAnswerMultiple.multipleValues || [];
          el.comment = el.addQuestionAnswerMultiple.comment || undefined;
          el.conditionalQuestion = null;
        }
        delete this.action.additionalQuestions[index].addQuestionAnswerMultiple;
      });

      api.put(`/widget/update-answer/${this.answer.id}`, {
        additionalQuestions: this.action.additionalQuestions,
        ...(this.dataContact.name && {name: this.dataContact.name}),
        ...(this.dataContact.email && {email: this.dataContact.email}),
        ...(this.dataContact.phone && {phone: this.dataContact.phone}),
      });

      this.verifyNextQuestion(this.position, this.action.additionalQuestions[this.position]);

      this.position += 1;
    },
    replaceTagNames(text, name) {
      return text
        .replace('&lt;pnome&gt;', name.split(' ')[0])
        .replace('&lt;nome&gt;', name);
    },
    handleClosingMessage() {
      if (this.action.closingMessageEnabled && this.action.closingMessage) {
        if (this.action.closingMessage.dynamic) {
          if (
            this.action.closingMessage.promoters &&
            this.promotersGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.action.closingMessage.promoters.useLogo;
            this.closingMessage.html = this.action.closingMessage.promoters.html;
          } else if (
            this.action.closingMessage.passives &&
            this.passivesGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.action.closingMessage.passives.useLogo;
            this.closingMessage.html = this.action.closingMessage.passives.html;
          } else if (
            this.action.closingMessage.detractors &&
            this.detractorsGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.action.closingMessage.detractors.useLogo;
            this.closingMessage.html = this.action.closingMessage.detractors.html;
          }
        } else if (this.action.closingMessage.default) {
          this.closingMessage.useLogo = this.action.closingMessage.default.useLogo;
          this.closingMessage.html = this.action.closingMessage.default.html;
        }
      }
    },
    getDeviceInfo() {
      let deviceInfo = null;
      try {
        deviceInfo = bowser.parse(window.navigator.userAgent);
      } catch (error) {
        window.console.log(error);
      }
      return deviceInfo;
    },
    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.indicators.length; i += 1) {
          if (
            item.selectedIndicator &&
            this.indicators[i].column.toLowerCase() ===
            item.selectedIndicator.toLowerCase()
          ) {
            if (
              this.indicators[i].value.toLowerCase() ===
              item.indicatorValue.toLowerCase()
            ) {
              return true;
            }
            break;
          }
        }
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  max-width: 920px;
  display: flex;
  margin-right: auto;
  margin-left: auto;
  padding: 0 5px;
  justify-content: center;
  height: 220px;
  overflow-x: hidden;
  overflow-y: auto;
  animation: appearsFromLeft 0.6s;
}
.addquestions-area {
  display: flex;
  flex-direction: column;
  animation: appearsFromLeft 0.6s;
  .guide {
    color: #c1c1c1;
    align-self: center;
  }
  .buttons-area {
    min-width: 300px;
    display: -webkit-box;
    justify-content: space-between;
    button {
      border: 0;
      background: 0;
      color: #21bb6b;
      transition: 0.3s;
      &:hover {
        color: #149150;
      }
    }
    .prev {
      align-self: flex-start;
    }
    .next {
      align-self: flex-end;
    }
  }
  .likert-adjust {
    // margin-top: 100px;
  }
}
.next {
  border: 0;
  background: 0;
  color: #21bb6b;
  transition: 0.3s;
  &:hover {
    color: #149150;
  }
}
.comment-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: appearsFromLeft 0.6s;
  textarea {
    width: 100%;
  }
  button {
    margin-top: 5px;
    align-self: flex-end;
  }
}
.thank-you-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@keyframes appearsFromLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media only screen and (min-width: 1200px) {
  .addquestions-area {
    min-width: 800px;
  }
}
@media only screen and (min-width: 600px) {
  .addquestions-area {
    .likert-adjust {
      margin-top: 0;
    }
  }
}

.btn-block {
  margin-top: 20px !important;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
  background: #462A71;
  border-color: #462A71;
  color: #ffffff;
}
</style>
<style>
hr {
  margin: 2px !important;
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/widget/index.vue